import { Bell } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { paths } from '@/app/paths';
import { Popover, PopoverContent, PopoverTrigger } from '@/design-system/ui/Menu';
import { relativeTime } from '@escala/domain/dates';
import { useNotifications } from '@/hooks/useNotifications';
import { useStore } from '@/store/AppStore';

import NotificationIcon from './NotificationIcon';
import { useOpenNotification } from './useOpenNotification';

/** Sino do cabeçalho: contador de não lidas e as 4 mais recentes. */
export default function NotificationsMenu() {
  const { actions } = useStore();
  const { items, unread } = useNotifications();
  const openNotification = useOpenNotification();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger
        aria-label={unread ? `Notificações: ${unread} não lidas` : 'Notificações'}
        className="relative grid size-10 place-items-center rounded-control text-ink-secondary hover:bg-header-hover"
      >
        <Bell aria-hidden className="size-4.5 stroke-[1.8]" />
        {unread ? (
          <span
            aria-hidden
            className="absolute top-1.25 right-1.25 grid h-4 min-w-4 place-items-center rounded-pill border-2 border-page bg-status-conflict-bar px-1 text-micro font-bold text-white"
          >
            {unread > 9 ? '9+' : unread}
          </span>
        ) : null}
      </PopoverTrigger>
      <PopoverContent aria-label="Notificações" className="w-[min(340px,calc(100vw-24px))]">
        <div className="flex items-center gap-2 border-b border-line-divider px-3.5 py-2.5">
          <span className="flex-1 text-body font-semibold">Notificações</span>
          {unread ? (
            <button
              type="button"
              onClick={() => actions.markRead(items.map((n) => n.id))}
              className="p-1 text-meta text-ink-muted"
            >
              Marcar como lidas
            </button>
          ) : null}
          <Link
            to={paths.notifications}
            onClick={() => setOpen(false)}
            className="p-1 text-meta font-semibold"
          >
            Ver todas
          </Link>
        </div>
        {items.slice(0, 4).map((n) => (
          <button
            key={n.id}
            type="button"
            onClick={() => {
              setOpen(false);
              openNotification(n);
            }}
            className="flex w-full gap-2.5 border-b border-line-divider bg-white px-3.5 py-3 text-left last:border-0 hover:bg-surface-subtle"
          >
            <NotificationIcon icon={n.icon} tone={n.tone} />
            <span className="flex min-w-0 flex-col gap-0.5">
              <span
                className={
                  n.unread
                    ? 'flex items-center gap-1.5 text-small font-semibold'
                    : 'flex items-center gap-1.5 text-small font-medium'
                }
              >
                {n.title}
                {n.unread ? (
                  <span aria-label="Não lida" className="size-1.75 shrink-0 rounded-pill bg-primary" />
                ) : null}
              </span>
              <span className="text-meta text-ink-muted">{n.text}</span>
              <span className="text-caption text-ink-subtle">{relativeTime(n.at)}</span>
            </span>
          </button>
        ))}
        {!items.length ? (
          <p className="m-0 px-3.5 py-5 text-small text-ink-subtle">Nenhuma notificação.</p>
        ) : null}
      </PopoverContent>
    </Popover>
  );
}
